import { render } from "./ManualIssueCoupon.vue?vue&type=template&id=126cd9ab&scoped=true"
import script from "./ManualIssueCoupon.vue?vue&type=script&lang=js"
export * from "./ManualIssueCoupon.vue?vue&type=script&lang=js"

import "./ManualIssueCoupon.vue?vue&type=style&index=0&id=126cd9ab&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/alice/alice_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-126cd9ab"]])

export default __exports__